import React from 'react';
import PropTypes from 'prop-types';
import CollapsibleTextAreaWithCounter from '../../components/CollapsibleTextAreaWithCounter';
import './styles.css';

class MessagingDiff extends React.Component {
  static propTypes = {
    data: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    entryId: PropTypes.string.isRequired,
    list: PropTypes.array,
  };

  static defaultProps = {
    data: [],
    list: [],
  };

  handleChange = (e, props) => {
    const { entryId, data, onChange } = this.props;
    const { name: oname, value } = props;

    const refId = oname.split('.')[0];

    let newData = Array.isArray(data) ? data: [];
    const aux = newData.find((d) => d.refId === refId);

    if (aux) {
      newData = newData.map((d) => {
        if (d.refId === refId) {
          return {
            ...d,
            message: value,
          };
        }
        return d;
      });
    } else {
      newData.push({
        refId,
        message: value,
      });
    }

    onChange(e, {
      name: `${entryId}.messaging`,
      value: newData,
    });
  }

  render() {
    const { entryId, data, list } = this.props;

    return list.map((entry) => {
      const { id, name } = entry;
      const fieldName = `${id}.message.${entryId}`;
      const ariaLabel = `Enter a message for ${name}`;
      const auxValue = Array.isArray(data) && data.find((d) => d.refId === id);
      const value = auxValue ? auxValue.message: '';
      const messagingDiffCy = `messaging-diff-${name}`;
      return (
        <div styleName="messaging-diff" key={fieldName}>
          <label styleName="messaging-diff-label" htmlFor={fieldName}>{name}</label>
          <CollapsibleTextAreaWithCounter
            onChange={this.handleChange}
            id={fieldName}
            name={fieldName}
            value={value}
            aria-label={ariaLabel}
            placeholder="Enter Message..."
            data-cy={messagingDiffCy}
          />
        </div>
      );
    });
  }
}

export default MessagingDiff;
